import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { apiFetch } from '../api';
import websocketService from '../services/websocketService';
import { envClosedBookOverride, isClosedBookEnabled, mergePolicy } from './securityPolicy';
import SecureExamProvider from './SecureExamProvider';

export default function SecureExamGate({
  examId: examIdProp,
  candidateId: candidateIdProp,
  children
}) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const examId = examIdProp || params.get('examId') || params.get('library_id') || '';
  const candidateId = candidateIdProp || params.get('userId') || '';
  const [resolved, setResolved] = useState(null);

  useEffect(() => {
    const env = envClosedBookOverride();
    if (env === false) {
      setResolved({ enabled: false, policy: mergePolicy({}) });
      return undefined;
    }
    if (!examId) {
      setResolved({ enabled: false, policy: mergePolicy({}) });
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch(`/api/exams/${encodeURIComponent(examId)}/security-policy`);
        const json = await res.json().catch(() => ({}));
        if (cancelled) return;
        const enabled = isClosedBookEnabled({
          examEnabled: json.examEnabled,
          featureFlagEnabled: json.featureFlagEnabled,
          hasTenant: json.hasTenant,
          envOverride: env
        });
        setResolved({ enabled: enabled && !!candidateId, policy: mergePolicy(json.policy) });
      } catch (_) {
        if (!cancelled) setResolved({ enabled: false, policy: mergePolicy({}) });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [examId, candidateId]);

  if (!resolved) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <SecureExamProvider
      enabled={resolved.enabled}
      examId={examId}
      candidateId={candidateId}
      policy={resolved.policy}
      request={apiFetch}
      websocketService={websocketService}
      requireEnvironmentCheck={resolved.enabled}
    >
      {children}
    </SecureExamProvider>
  );
}

export { SecureExamGate };
